import {
    Tooltip, IconButton, Icon, Button, Divider, Typography, CircularProgress, Dialog, DialogTitle,
    DialogActions, DialogContent, DialogContentText, FormControl, InputLabel, Select, MenuItem,
    TextField,
    Box,
    Snackbar
} from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { wsObtenerUsuarios } from 'api/APIDraft'
import { DocumentPicker } from 'components'
import { AuthContext } from 'context'
import { DASHBOARD_PATH, DOCUMENT_PATH } from 'lib'
import React from 'react'
import { useHistory } from 'react-router'
import { IUser } from 'types'

interface Props {
    title: string
    onSubmit: (approverId: number | undefined) => Promise<void>
    loading: boolean
    draft?: boolean
    onSubmitDraft: () => void
    canOpenApproverDialog?: boolean
    hasNonTaxSupport?: boolean
    hasFiles?: boolean
}

const DocumentActions = (props: Props) => {
    const history = useHistory()
    const { user } = React.useContext(AuthContext)
    const [openPicker, setOpenPicker] = React.useState<boolean>(false)
    const { title, loading, onSubmit, draft, onSubmitDraft, hasNonTaxSupport, hasFiles, canOpenApproverDialog } = props
    const [openDialog, setOpenDialog] = React.useState(false);
    const [openDialogDraft, setOpenDialogDraft] = React.useState(false);
    const [faltaAprobador, setFaltaAprobador] = React.useState(false);
    const [usuarios, setusuarios] = React.useState<IUser[]>([])
    const [aprobador, setaprobador] = React.useState<IUser | undefined>(undefined);

    const [showFileAlert, setShowFileAlert] = React.useState(false)

    const accionGuardarBorrador = () => {
        onSubmitDraft()
        setOpenDialogDraft(false);
    }

    const accionCrear = async () => {
        if (aprobador) {
            setFaltaAprobador(false);
            setProcesandoDocumento(true);
            let seconds = 10;
            setCountdown(seconds);
            const interval = setInterval(() => {
                seconds--;
                setCountdown(seconds);
                if (seconds <= 0) {
                    clearInterval(interval);
                    setOpenDialog(false);
                    setProcesandoDocumento(false);
                    if (
                        title.toUpperCase() === 'REEMBOLSO DE EMPLEADOS' ||
                        title.toUpperCase() === 'REPOSICIÓN DE CAJA CHICA'
                    ) {
                        history.push('/reembolsos/mydocs');
                    } else {
                        history.push('/reembolsos/dashboard');
                    }
                }
            }, 1000);
            const aprobadorId =
                aprobador !== undefined
                    ? aprobador.userId
                    : undefined;
            await onSubmit(aprobadorId);
        } else {
            setFaltaAprobador(true);
        }
    }

    // SELECCIONAR APROBADOR

    const handleChange = (event: any) => {
        const usuarioSeleccionado = usuarios.find(
            usuario => usuario.name === event.target.value
        )

        setaprobador(usuarioSeleccionado)
    }

    React.useEffect(() => {
        obtenerUusariosAprobacion()
    }, [])

    const obtenerUusariosAprobacion = async () => {
        const result = await wsObtenerUsuarios();
        setusuarios(result)
    }

    const [searchAprobador, setSearchAprobador] = React.useState('')

    const [procesandoDocumento, setProcesandoDocumento] = React.useState(false)
    const [countdown, setCountdown] = React.useState(10)
    const [showAdvanceAlert, setShowAdvanceAlert] = React.useState(false)

    const handleCreateClick = () => {

        const isReimbursement =
            title.toUpperCase() === 'REEMBOLSO DE EMPLEADOS' ||
            title.toUpperCase() === 'REPOSICIÓN DE CAJA CHICA'

        if (!isReimbursement) {
            onSubmit(undefined)
            return
        }

        // NUEVA VALIDACIÓN
        if (!canOpenApproverDialog) {
            setShowAdvanceAlert(true)
            return
        }

        // Si hay sustentos no tributarios y no hay archivos
        if (hasNonTaxSupport && !hasFiles) {
            setShowFileAlert(true)
            return
        }

        // Todo OK → abrir dialogo aprobador
        setOpenDialog(true)
    }

    const usuariosFiltrados = [...usuarios]
        .sort((a, b) => a.name.localeCompare(b.name))
        .filter(usuario =>
            usuario.name.toLowerCase().includes(searchAprobador.toLowerCase())
        )


    const APROBAR_POR_CORREO: IUser = {
        name: 'EMPLEADO REGIONAL',
        userId: 0,
        email: '',
        password: '',
        active: true,
        identification: '',
        canApprove: false,
        canReject: false,
        canRequest: false,
        canCancel: false,
        rolReembolso: '',
        nivelCreacion: 0,
        validUntil: new Date()
    }

    const usuariosConCorreo = [
        APROBAR_POR_CORREO,
        ...usuariosFiltrados
    ]

    return (
        <div className="mt-4 flex justify-between">
            <div className="h-full flex items-center pl-2">
                <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600, letterSpacing: 0.5 }}>
                    {title}
                </Typography>
            </div>
            <div className="flex">
                <div className="mx-3 h-full flex items-center">
                    <Tooltip arrow title="Regresar a dashboard">
                        <IconButton
                            disabled={loading}
                            size="small"
                            onClick={() => history.push(`${DOCUMENT_PATH}${DASHBOARD_PATH}`)}
                        >
                            <Icon>
                                chevron_left
                            </Icon>
                        </IconButton>
                    </Tooltip>
                </div>
                <Button
                    variant="contained"
                    disableElevation
                    disabled={loading}
                    type="submit"
                    onClick={() => setOpenPicker(true)}
                >
                    {"Cambiar tipo de documento"}
                </Button>
                <div className="mx-3">
                    <Divider orientation="vertical" />
                </div>
                {Boolean(draft) &&
                    <>
                        <Button
                            variant="contained"
                            disableElevation
                            disabled={loading}
                            type="submit"
                            /* onClick={() => onSubmitDraft()} */
                            onClick={() => setOpenDialogDraft(true)}
                        >
                            {"Guardar Borrador"}
                        </Button>
                        <div className="mx-3">
                            <Divider orientation="vertical" />
                        </div>
                    </>
                }
                <Button
                    color="primary"
                    variant="contained"
                    disableElevation
                    disabled={loading}
                    /* CAMBIOS PARA REGRESO DE VERSION */
                    onClick={handleCreateClick}
                /* CAMBIOS PARA REGRESO DE VERSION */
                /* onClick={() => onSubmit(undefined)}  */
                >
                    {loading ? <CircularProgress style={{ color: "white" }} size={16} className="my-1" thickness={10} /> : "Crear"}
                </Button>
            </div>
            <DocumentPicker
                open={openPicker}
                onClose={() => setOpenPicker(false)}
            />
            <Dialog open={openDialogDraft} onClose={() => setOpenDialogDraft(false)} maxWidth="xl">
                <div style={{ padding: '20px 30px' }}>
                    <DialogTitle>¿Guardar el documento como borrador?</DialogTitle>
                    <DialogActions style={{ padding: '0px' }}>
                        <Button variant="contained" disableElevation onClick={() => setOpenDialogDraft(false)}>Cancelar</Button>
                        <Button color="primary" variant="contained" disableElevation onClick={() => accionGuardarBorrador()} autoFocus>Guardar</Button>
                    </DialogActions>
                </div>

            </Dialog>
            <Dialog
                open={openDialog}
                disableEscapeKeyDown={procesandoDocumento}
                onClose={(event, reason) => {
                    if (procesandoDocumento) {
                        return;
                    }

                    setOpenDialog(false);
                }}
                maxWidth="sm"
                fullWidth
            >
                <div style={{ padding: '20px 30px' }}>

                    {!procesandoDocumento ? (

                        <>
                            <DialogContent style={{ padding: 0 }}>
                                <Typography>
                                    Seleccione el aprobador del documento:
                                </Typography>

                                <br />

                                {faltaAprobador && (
                                    <Alert
                                        severity="error"
                                        style={{
                                            padding: '0px 16px',
                                            marginBottom: '20px'
                                        }}
                                    >
                                        <Typography className="pl-2" variant="caption">
                                            Para crear el documento, debe seleccionar un aprobador.
                                        </Typography>
                                    </Alert>
                                )}

                                {/* BUSCADOR */}
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    label="Buscar aprobador"
                                    value={searchAprobador}
                                    onChange={(e) => setSearchAprobador(e.target.value)}
                                />

                                {/* LISTADO */}
                                <Box
                                    mt={2}
                                    border={1}
                                    borderColor="#dcdcdc"
                                    borderRadius={8}
                                    style={{
                                        maxHeight: '300px',
                                        overflowY: 'auto'
                                    }}
                                >
                                    {usuariosConCorreo.length > 0 ? (
                                        usuariosConCorreo.map((usuario, index) => {

                                            const seleccionado =
                                                aprobador?.name === usuario.name

                                            return (
                                                <Box
                                                    key={index}
                                                    px={2}
                                                    py={1.5}
                                                    display="flex"
                                                    alignItems="center"
                                                    justifyContent="space-between"
                                                    onClick={() => setaprobador(usuario)}
                                                    style={{
                                                        cursor: 'pointer',
                                                        backgroundColor:
                                                            seleccionado
                                                                ? (usuario.userId === 0 ? '#f3e460' : '#b8cad6')
                                                                : (usuario.userId === 0 ? '#f3e460' : 'transparent'),
                                                        borderBottom:
                                                            index !== usuariosConCorreo.length - 1
                                                                ? '1px solid #f0f0f0'
                                                                : 'none'
                                                    }}
                                                >
                                                    <Typography variant="body2">
                                                        {usuario.name}
                                                    </Typography>

                                                    {seleccionado && (
                                                        <Typography
                                                            variant="caption"
                                                            color="primary"
                                                        >
                                                            Seleccionado
                                                        </Typography>
                                                    )}
                                                </Box>
                                            )
                                        })
                                    ) : (
                                        <Box p={2}>
                                            <Typography
                                                variant="body2"
                                                color="textSecondary"
                                            >
                                                No se encontraron aprobadores
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                            </DialogContent>

                            <DialogActions style={{ marginTop: '20px' }}>
                                <Button
                                    variant="contained"
                                    disableElevation
                                    onClick={() => setOpenDialog(false)}
                                >
                                    Cancelar
                                </Button>

                                <Button
                                    color="primary"
                                    variant="contained"
                                    disableElevation
                                    onClick={() => accionCrear()}
                                    autoFocus
                                >
                                    Aceptar
                                </Button>
                            </DialogActions>
                        </>

                    ) : (

                        <DialogContent
                            style={{
                                textAlign: 'center',
                                padding: '30px 10px'
                            }}
                        >

                            <CircularProgress />

                            <Typography
                                variant="h6"
                                style={{ marginTop: '20px' }}
                            >
                                Procesando documento
                            </Typography>

                            <Typography
                                variant="body2"
                                color="textSecondary"
                                style={{ marginTop: '10px' }}
                            >
                                El documento está siendo procesado.
                            </Typography>

                            <Typography
                                variant="body1"
                                style={{
                                    marginTop: '20px',
                                    fontWeight: 600
                                }}
                            >
                                Redirigiendo en {countdown} segundos...
                            </Typography>

                        </DialogContent>

                    )}

                </div>
            </Dialog>
            <Snackbar
                open={showFileAlert}
                autoHideDuration={5000}
                onClose={() => setShowFileAlert(false)}
                anchorOrigin={{
                    horizontal: "right",
                    vertical: "bottom"
                }}
            >
                <Alert
                    variant="filled"
                    severity="warning"
                    onClose={() => setShowFileAlert(false)}
                >
                    Existen sustentos no tributarios. Debe cargar al menos un archivo de respaldo.
                </Alert>
            </Snackbar>
            <Snackbar
                open={showAdvanceAlert}
                autoHideDuration={5000}
                onClose={() => setShowAdvanceAlert(false)}
                anchorOrigin={{
                    horizontal: "right",
                    vertical: "bottom"
                }}
            >
                <Alert
                    variant="filled"
                    severity="warning"
                    onClose={() => setShowAdvanceAlert(false)}
                >
                    Debe ingresar el valor del motivo antes de seleccionar un aprobador.
                </Alert>
            </Snackbar>
        </div >
    )
}

export default DocumentActions
